export default "__VITE_ASSET__e70c4d2c__"